import React from 'react';
import { useFormContext } from 'react-hook-form';

import { NumberFormatNorwegianCurrency } from '@eika/currency-input';

import './AmountInput.scss';

interface NumberFormatValues {
    floatValue: number | undefined;
    formattedValue: string;
    value: string;
}

export const AmountInput = () => {
    const [value, setValue] = React.useState<number | undefined>(undefined);
    const context = useFormContext();
    const [hasFocus, setHasFocus] = React.useState(false);

    const handleChange = (values: NumberFormatValues) => {
        setValue(values.floatValue);
        context.setValue('amount', values.floatValue);
    };
    const handleFocus = () => {
        setHasFocus(true);
    };

    const handleBlur = () => {
        setHasFocus(false);
    };

    return (
        <div className="amount-input">
            <NumberFormatNorwegianCurrency
                aria-label="Beløp"
                id="transfer-payment-amount"
                className="amount-input__amount"
                onValueChange={handleChange}
                value={value}
                autoComplete="off"
                maxLength={12}
                decimalScale={0}
                placeholder={hasFocus ? '   kr' : '0 kr'}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </div>
    );
};
